import { MainMenuItem } from "types/MainMenuItem";

// Constants
import { FAQ_URL, TELEGRAM_URL } from "./constants";
import { FAQ, SUPPORT } from "./analytics";

export const menuItems: MainMenuItem[] = [
  {
    key: "liquid-staking",
    label: "BNB",
    iconKey: "bnb",
    disabled: false,
    to: "/liquid-staking/bnbx",
    subMenus: [
      {
        key: "bnbx",
        label: "Stake",
        disabled: false,
        to: "/liquid-staking/bnbx",
      },
      {
        key: "defi",
        label: "DeFi",
        disabled: false,
        badge: "new",
        to: "/liquid-staking/defi",
      },
      {
        key: "portfolios",
        label: "Portfolios",
        to: "/portfolios",
        disabled: false,
      },
    ],
  },
];

export const liquidStakingOptions = [
  {
    key: "hedera",
    title: "Hedera",
    link: "https://hedera.staderlabs.com/lt/hedera",
  },
  {
    key: "polygon",
    title: "Polygon",
    link: "https://www.staderlabs.com/polygon",
  },
  {
    key: "fantom",
    title: "Fantom",
    link: "https://fantom.staderlabs.com/liquid-staking/pools",
  },
  {
    key: "near",
    title: "Near",
    link: "https://near.staderlabs.com",
  },
  {
    key: "terra",
    title: "Terra",
    link: "https://terra.staderlabs.com/liquid-staking",
  },
];

export const extraItems = [
  {
    title: `Theme`,
    key: "theme",
  },
  {
    key: "faq",
    title: "FAQs",
    link: FAQ_URL,
    event: FAQ,
  },
  {
    key: "support",
    title: "Support",
    link: TELEGRAM_URL,
    event: SUPPORT,
  },
];
